import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces";
import { ITomaFisica, ITomaFisicaPagingRes, ITomaFisicaParams } from "@/shared/interfaces/erp/contabilidad/toma_fisica.interface";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import {  useMutation, useQuery } from "@tanstack/react-query";

const { get, post, put } = erpApi();

///* obtener toma fisica
export const useFetchGetTomaFisica = (
  params?: ITomaFisicaParams,
  enabled = true
) => {
  return useQuery({
    queryKey: ['tomafisica', ...Object.values(params || {})],
    queryFn: async () => {
      return await getTomaFisica(params);
    },
    enabled,
  });
};

export const getTomaFisica = async (params?: ITomaFisicaParams) => {
  const queryParams = getUrlParamsFetch(params || {})
  const resp = await get<ITomaFisicaPagingRes>(`${urlBackend}api/v1/tomafisica/?${queryParams}`, true);
  return resp;
};

///* obtener toma fisica por su id
export const useFetchGetTomaFisicaById = (
  id: string,
  enabled = true
) => {
  return useQuery({
    queryKey: ['tomafisica', id],
    queryFn: async () => {
      return await getTomaFisicaById(id);
    },
    enabled,
  });
};

export const getTomaFisicaById = async (id: string) => {
  const resp = await get<ITomaFisica>(`${urlBackend}api/v1/tomafisica/${id}/`, true);
  return resp;
};

///* crear una toma fisica
export const useFetchPostTomaFisica = (
  {
    navigate,
    returnUrl
  }: UseMutationsParams = {}
) => {

  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async ({ data }: {
      data: ITomaFisicaParams
    }) => {
      return postTomaFisica(data);
    },
    onSuccess: (data) => {

      if (navigate && returnUrl) {
        navigate(returnUrl)
      }

      setAlert(true, data.message, AlertSeverityEnum.success);
      
    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
    }
  });
}

export const postTomaFisica = async (data: ITomaFisicaParams) => {
  const resp = await post<ITomaFisica>(`${urlBackend}api/v1/tomafisica/`, data, true);
  return resp;
}


///* actualizar toma fisica

export const useFetchPutTomaFisica = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {

  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async ({ id, data }: {
      id: string,
      data: ITomaFisicaParams
    }) => {
      return putTomaFisica(id, data);
    },
    onSuccess(data) {
      setAlert(true, data.message, AlertSeverityEnum.info);

      navigate && returnUrl && navigate(returnUrl)

    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
    }
  });
}

export const putTomaFisica = async (id: string, data: ITomaFisicaParams) => {
  const resp = await put<ITomaFisica>(`${urlBackend}api/v1/tomafisica/${id}/`, data, true);
  return resp;
}
